"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var tslib_1 = require("tslib");

var ui_helper_deep_branding_1 = require("@hopin-team/ui-helper-deep-branding");

var ui_helper_with_space_1 = require("@hopin-team/ui-helper-with-space");

var react_1 = tslib_1.__importStar(require("react"));

var inner_1 = require("./partials/inner");

var root_1 = require("./styled/root");

var Button = react_1.forwardRef(function (_a, ref) {
  var __UIScope = _a.__UIScope,
      children = _a.children,
      className = _a.className,
      disabled = _a.disabled,
      isInverse = _a.isInverse,
      isOutlined = _a.isOutlined,
      leadingIcon = _a.leadingIcon,
      onClick = _a.onClick,
      _b = _a.pattern,
      pattern = _b === void 0 ? 'primary' : _b,
      _c = _a.size,
      size = _c === void 0 ? 'medium' : _c,
      trailingIcon = _a.trailingIcon,
      props = tslib_1.__rest(_a, ["__UIScope", "children", "className", "disabled", "isInverse", "isOutlined", "leadingIcon", "onClick", "pattern", "size", "trailingIcon"]);

  var handleClick = function handleClick(event) {
    if (!('href' in props) && !disabled) {
      onClick === null || onClick === void 0 ? void 0 : onClick(event);
    }
  };

  var rootClasses = ui_helper_deep_branding_1.useEscapeClasses({
    block: 'Button',
    className: className,
    __UIScope: __UIScope
  }).rootClasses;

  if ('href' in props) {
    return react_1.default.createElement(root_1.Root, tslib_1.__assign({
      ref: ref,
      size: size,
      pattern: pattern,
      as: "a",
      className: rootClasses,
      isLeading: !!leadingIcon,
      isTrailing: !!trailingIcon,
      isOutlined: isOutlined,
      isInverse: isInverse
    }, props), react_1.default.createElement(inner_1.Inner, {
      isOutlined: isOutlined,
      isInverse: isInverse,
      leadingIcon: leadingIcon,
      trailingIcon: trailingIcon,
      size: size,
      disabled: disabled
    }, children));
  }

  return react_1.default.createElement(root_1.Root, tslib_1.__assign({
    ref: ref,
    size: size,
    pattern: pattern,
    className: rootClasses,
    "aria-disabled": Boolean(disabled),
    onClick: handleClick,
    isLeading: !!leadingIcon,
    isTrailing: !!trailingIcon,
    isOutlined: isOutlined,
    isInverse: isInverse
  }, props), react_1.default.createElement(inner_1.Inner, {
    isOutlined: isOutlined,
    isInverse: isInverse,
    leadingIcon: leadingIcon,
    trailingIcon: trailingIcon,
    size: size,
    disabled: disabled
  }, children));
});
Button.displayName = 'Button';
var ButtonWithSpace = ui_helper_with_space_1.withSpace(Button);
exports.Button = ButtonWithSpace;